var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fields.id
    ? _c(
        "div",
        {
          staticClass: "tab-pane fade",
          attrs: {
            "aria-labelledby": "captain-tab",
            id: "captain",
            role: "tabpanel"
          }
        },
        [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("input-text", {
                attrs: { options: { id: "id", label: "id", disabled: true } },
                model: {
                  value: _vm.fields.id,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "id", $$v)
                  },
                  expression: "fields.id"
                }
              }),
              _c("input-text", {
                attrs: {
                  options: { id: "name", label: "name", disabled: true }
                },
                model: {
                  value: _vm.fields.name,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "name", $$v)
                  },
                  expression: "fields.name"
                }
              }),
              _c("input-text", {
                attrs: {
                  options: {
                    id: "mobile_number",
                    label: "mobile_number",
                    disabled: true
                  }
                },
                model: {
                  value: _vm.fields.mobileNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "mobileNumber", $$v)
                  },
                  expression: "fields.mobileNumber"
                }
              })
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }